import ListActions from "modules/list/actions";
import api from "services/api";
import store from "services/store";
import { getCluster } from "state/cluster/selectors/details";
import { CronJobSchema } from "utils/schemas";

export const CRONJOBS_MODULE = "cronjobs";

export const cronjobsListingActions = new ListActions({
  async fetchData({ filterBy = [] } = {}) {
    const cluster = getCluster(store.getState());

    const data = await api.post(
      `v1/dashboard/spectroclusters/${cluster.metadata.uid}/workloads/cronjob`,
      {
        filter: {
          namespaces: filterBy,
        },
      }
    );

    return {
      items: (data?.cronJobs || []).sort((job1, job2) =>
        job1.metadata.namespace > job2.metadata.namespace ? 1 : -1
      ),
    };
  },
  initialQuery: () => ({
    filterBy: [],
  }),
  schema: [CronJobSchema],
});
